export default __webpack_public_path__ + "static/media/Graphik-SemiboldItalic.606f93e5.otf";